import * as Types from '../../types.generated';

import { api } from '../../rootApi';
export type CustomPlaylistQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  page: Types.Scalars['Int'];
  perPage: Types.Scalars['Int'];
}>;

export type CustomPlaylistQuery = {
  __typename?: 'Query';
  customPlaylist?:
    | {
        __typename?: 'PlaylistBase';
        name?: string | null | undefined;
        id: number;
        totalDuration?: number | null | undefined;
        coverArt?:
          | { __typename?: 'Attachment'; id: number; url: string }
          | null
          | undefined;
        playlistSongs?:
          | {
              __typename?: 'PlaylistSongList';
              data?:
                | Array<{
                    __typename?: 'PlaylistSong';
                    id: number;
                    position?: number | null | undefined;
                    song?:
                      | {
                          __typename?: 'BaseSongType';
                          id: number;
                          title: string;
                          trackLength: number;
                          isFavourited: boolean;
                          lowQuality?:
                            | {
                                __typename?: 'Attachment';
                                url: string;
                                id: number;
                              }
                            | null
                            | undefined;
                          mediumQuality?:
                            | {
                                __typename?: 'Attachment';
                                url: string;
                                id: number;
                              }
                            | null
                            | undefined;
                          highQuality?:
                            | {
                                __typename?: 'Attachment';
                                url: string;
                                id: number;
                              }
                            | null
                            | undefined;
                          raga: {
                            __typename?: 'Raga';
                            id: number;
                            title: string;
                            timeSections?:
                              | Array<{
                                  __typename?: 'TimeSection';
                                  name: string;
                                  gradientTopColour: string;
                                  gradientBottomColour: string;
                                }>
                              | null
                              | undefined;
                          };
                          artists: {
                            __typename?: 'ArtistsConnection';
                            edges?:
                              | Array<
                                  | {
                                      __typename?: 'ArtistsEdge';
                                      node?:
                                        | {
                                            __typename?: 'Artist';
                                            id: number;
                                            firstName: string;
                                            lastName?:
                                              | string
                                              | null
                                              | undefined;
                                            bio?: string | null | undefined;
                                            musicInstrument?:
                                              | {
                                                  __typename?: 'MusicalInstrument';
                                                  name: string;
                                                }
                                              | null
                                              | undefined;
                                            profilePicture?:
                                              | {
                                                  __typename?: 'Attachment';
                                                  filename: string;
                                                  url: string;
                                                }
                                              | null
                                              | undefined;
                                          }
                                        | null
                                        | undefined;
                                    }
                                  | null
                                  | undefined
                                >
                              | null
                              | undefined;
                          };
                        }
                      | null
                      | undefined;
                  }>
                | null
                | undefined;
              paging: {
                __typename?: 'Paging';
                currentPage: number;
                totalItems: number;
                totalPages: number;
              };
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CustomPlaylistListQueryVariables = Types.Exact<{
  page: Types.Scalars['Int'];
}>;

export type CustomPlaylistListQuery = {
  __typename?: 'Query';
  customPlaylistList: {
    __typename?: 'PlaylistList';
    data?:
      | Array<{
          __typename?: 'PlaylistBase';
          name?: string | null | undefined;
          id: number;
          coverArt?:
            | { __typename?: 'Attachment'; id: number; url: string }
            | null
            | undefined;
        }>
      | null
      | undefined;
  };
};

export const CustomPlaylistDocument = `
    query customPlaylist($id: Int!, $page: Int!, $perPage: Int!) {
  customPlaylist(id: $id) {
    name
    coverArt {
      id
      url
    }
    id
    totalDuration
    playlistSongs(page: $page, perPage: $perPage) {
      data {
        id
        position
        song {
          id
          title
          trackLength
          isFavourited
          lowQuality {
            url
            id
          }
          mediumQuality {
            url
            id
          }
          highQuality {
            url
            id
          }
          raga {
            id
            title
            timeSections {
              name
              gradientTopColour
              gradientBottomColour
            }
          }
          artists {
            edges {
              node {
                id
                firstName
                lastName
                bio
                musicInstrument {
                  name
                }
                profilePicture {
                  filename
                  url
                }
              }
            }
          }
        }
      }
      paging {
        currentPage
        totalItems
        totalPages
      }
    }
  }
}
    `;
export const CustomPlaylistListDocument = `
    query customPlaylistList($page: Int!) {
  customPlaylistList(page: $page) {
    data {
      name
      id
      coverArt {
        id
        url
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    customPlaylist: build.query<
      CustomPlaylistQuery,
      CustomPlaylistQueryVariables
    >({
      query: (variables) => ({ document: CustomPlaylistDocument, variables }),
    }),
    customPlaylistList: build.query<
      CustomPlaylistListQuery,
      CustomPlaylistListQueryVariables
    >({
      query: (variables) => ({
        document: CustomPlaylistListDocument,
        variables,
      }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useCustomPlaylistQuery,
  useLazyCustomPlaylistQuery,
  useCustomPlaylistListQuery,
  useLazyCustomPlaylistListQuery,
} = injectedRtkApi;
